import axios, { AxiosResponse } from 'axios';
import { ErrorCodes } from 'common/constants';
import { toast } from 'react-toastify';
import { clearAllDataBrowser, getToken } from 'utils/helpers';
const baseUrl = process.env.REACT_APP_URL_API;
const options = {
    baseURL: baseUrl,
    headers: {
        Authorization: `Bearer `,
        'Content-type': 'application/json',
    },
};

const axiosInstance = axios.create(options);
axiosInstance.interceptors.request.use(async (request) => {
    const token = getToken();
    request.headers.Authorization = `Bearer ${token}`;

    if (request.data instanceof FormData) {
        request.headers['Content-Type'] = 'multipart/form-data';
    } else {
        request.headers['Content-Type'] = 'application/json';
    }
    return request;
});

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        // Handle binary responses (like Excel files)
        const contentType = response.headers['content-type'];
        if (
            contentType &&
            (contentType.includes(
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ) ||
                contentType.includes('application/octet-stream') ||
                contentType.includes('application/excel') ||
                // csv
                contentType.includes('text/csv'))
        ) {
            return response;
        }
        if (response.data.status_code === ErrorCodes.UNAUTHORIZED) {
            window.location.href = '/login';
            clearAllDataBrowser();
        }
        if (response.data.status_code === ErrorCodes.FORBIDDEN) {
            toast.error('Không có quyền truy cập');
            return Promise.reject(new Error('Không có quyền truy cập'));
        }
        return response;
    },
    function (error) {
        // For blob response errors, read the blob as text to extract the error message
        if (error.response?.data instanceof Blob) {
            return new Promise((_, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result as string);
                        reject(
                            new Error(errorData.message || 'Download failed')
                        );
                    } catch (e) {
                        reject(new Error('Failed to download file'));
                    }
                };
                reader.onerror = () => {
                    reject(new Error('Failed to download file'));
                };
                reader.readAsText(error.response.data);
            });
        }

        if (error.response?.data?.message) {
            return Promise.reject(new Error(error.response.data.message));
        } else {
            return Promise.reject(
                new Error('Hệ thống đang bận, vui lòng thử lại sau')
            );
        }
    }
);

export default axiosInstance;
